import { render } from "./detail-hr-review.vue?vue&type=template&id=5d2e2032"
import script from "./detail-hr-review.vue?vue&type=script&lang=js"
export * from "./detail-hr-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__